import CityPageTemplate from "../city-template/CityPageTemplate";
import { lebanonConfig } from "./data";

export default function LebanonPage() {
  return <CityPageTemplate config={lebanonConfig} />;
}